export enum SupportingTableId {
  AgencyCodeNameMapping = 'agency-code-name-mapping',
  AgentSuppressions = 'agent-suppressions',
  AgencyNtp = 'agency-ntp',
  NtpMgaTerminatedAgents = 'ntp-mga-terminated-agents',
  AgencyRmd = 'agency-rmd',
  ForestersTable = 'foresters-table',
  MgaTable = 'mga-table',
  NlgProdNameTable = 'nlg-prod-name-table',
  AgentMgaCorrections = 'agent-mga-corrections',
  CarriersTable = 'carriers-table',
  GpmEquisMgaUpdate = 'gpm-equis-mga-update',
}

export const SUPPORTING_TABLE_IDS = Object.values(SupportingTableId) as SupportingTableId[];

export enum SupportingTableImportStatus {
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}

export const SUPPORTING_TABLE_IMPORT_STATUSES = Object.values(
  SupportingTableImportStatus,
) as SupportingTableImportStatus[];
